import getServicos from "@/utils/getServicos"
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from "@/components/ui/select"

export function InputFilterServico({ servico, setFilter, setor }) {

  const servicos = getServicos(setor)
  const empty = servicos.length === 0

  function handleChange(value) {
    setFilter(value || "")
  }

  return (
    <Select value={servico} onValueChange={handleChange}>
      <SelectTrigger className="flex-1">
        <SelectValue placeholder="Filtrar serviço" />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {empty ? <SelectLabel>Serviços não encontrado</SelectLabel> : <SelectLabel>Filtrar setor</SelectLabel>}
          {(empty || servico) && <SelectItem>Todos Serviços</SelectItem>}
          {servicos.sort((a, b) => a.label.localeCompare(b.label)).map((item, idx) => (
            <SelectItem key={idx} value={item.id}>{item.label}</SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  )
}